
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {Question} from '@/lib/Question';
    import Choice from "@/lib/Choice";
    import SelectComponent from '@/components/SelectComponent.vue';

    @Component({
        components: {
            SelectComponent,
        },
    })
    export default class RadioQuestion extends Vue {
        @Prop() public question: Question;
        public optionId?: number = 0;
        public selected: Choice | null = null;

        public choose(){
            setTimeout(() => {
                this.$emit('chosen');
            }, 500);

        }

        public selectOption(option: any) {
            // console.log('changed');
            this.question.currentResponse!.value = option!.code;
            this.question.currentResponse!.valueId = option!.id;
            this.question.changedEvent.emit('changed');
            this.question.validate();
            // this.selected = option;
            // this.$set(this, 'selected', selected);
        }

        public answerIsEmpty() {
            return !this.question.currentResponse || (!this.question.currentResponse.value.length && 0 === this.question.currentResponse.valueId);
        }


        public mounted() {

            if (this.question.options.length === 2 && this.question.responseType.template !== 'select') {
                const answerIsEmpty = this.answerIsEmpty();
                if (!answerIsEmpty) {
                    const checkbox = this.$refs.radio0;
                    checkbox.checked = this.question.currentResponse!.valueId === this.question.options[0].id;
                } else {
                    this.question.currentResponse!.value = this.question.options[1].code;
                    this.question.currentResponse!.valueId = this.question.options[1].id;
                }
                this.question.changedEvent.emit('changed');
                this.question.validate();
            }
            if (this.question.options.length > 2) {
                const selected = this.answerIsEmpty() ? null : this.question.options.find((option: Choice) => option.id === this.question.currentResponse!.valueId) || null;
                this.$set(this, 'selected', selected);
                // console.log(this.selected);
            }
            // console.log(this.selected);
            // return;

        }

        public updateResponse() {
            const option = this.question.options.find((option: Choice) => {
                return option.id === this.optionId;
            });
            this.question.currentResponse!.value = option!.code;
            this.question.currentResponse!.valueId = option!.id;
            this.question.changedEvent.emit('changed');
            this.question.validate();
        }

        public updateBinary() {
            const first = this.$refs.radio0;
            const chosen = first[0].checked ? 0 : 1;
            this.question.currentResponse.value = this.question.options[chosen].code;
            this.question.currentResponse.valueId = this.question.options[chosen].id;

            this.question.changedEvent.emit('changed');
            this.question.validate();
        }

        public beforeDestroy() {
            if (this.$refs.hasOwnProperty('input-' + this.question.id)) {
                const instance = window.M.FormSelect.getInstance(this.$refs['input-' + this.question.id]);
                instance.destroy();
            }
        }
    }
